import React, { Component } from 'react'

// redux
import { Provider } from 'react-redux'
import { store } from '../redux/store'
import { LocaleProvider } from 'antd'
import Vietnamese from 'antd/es/locale/vi_VN'
import moment from 'moment'
import 'moment/locale/vi'

import Boot from '../redux/boot'

import App from './app'
moment.locale('vi')

class AppContainer extends Component {
    render() {
        return (
            <Provider store={store}>
                <LocaleProvider locale={Vietnamese}>
                    <App />
                </LocaleProvider>
            </Provider>
        )
    }
}

Boot()
    .then(() => AppContainer())
    .catch(error => console.log('render error : ', error))

export default AppContainer
